const updates = [
  {
    id: 1,
    date: '07-30',
    title: '《星河长明》更新至36集',
    desc: '古装玄幻大剧最新剧情，主角突破境界引发天地异象',
    tag: '热播剧集',
  },
  {
    id: 2,
    date: '07-30',
    title: '《风暴追击》VIP全集上线',
    desc: '超燃动作大片，院线同步上线，限时免费观看',
    tag: '最新电影',
  },
  {
    id: 3,
    date: '07-29',
    title: '《欢乐周末》最新一期更新',
    desc: '全明星阵容笑料不断，本季最强综艺不容错过',
    tag: '热门综艺',
  },
  {
    id: 4,
    date: '07-29',
    title: '《星际纪元》大结局上线',
    desc: '国产科幻动漫口碑之作完美收官，全集一键畅看',
    tag: '国产动漫',
  },
  {
    id: 5,
    date: '07-28',
    title: '韩剧《秘密花园》重制版上线',
    desc: '经典韩剧高清重制，唤醒你的追剧回忆',
    tag: '经典回顾',
  },
  {
    id: 6,
    date: '07-28',
    title: '《暗夜追踪》悬疑新剧首播',
    desc: '国产悬疑黑马，首播三集口碑爆棚',
    tag: '新剧上线',
  },
  {
    id: 7,
    date: '07-27',
    title: '暑期档片单全面更新',
    desc: '30+部新剧同步上线，暑期追剧指南已就位',
    tag: '特别策划',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            最新更新
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            实时追踪，不错过每一部好剧
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, index) => (
            <div
              key={item.id}
              className={`relative flex gap-4 md:gap-6 ${
                index < updates.length - 1 ? 'pb-6 md:pb-8' : ''
              }`}
            >
              {index < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300/60"></div>
              )}
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">
                  {item.date}
                </span>
              </div>
              <div className="flex-1 min-w-0 pt-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}